// @core/api/endpoints/product/list_products.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListProductsResponse,
} from '../../../types/product';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/product';

/**
 * List available products
 * Returns a paginated list of products available in the catalog. Supports filtering by status, category, and built-in flag, as well as text search.
 * @public This endpoint does not require authentication
 */
export async function ListProducts(
  params?: PaginatedRequest & {
    category?: string | number | boolean;
    is_builtin?: string | number | boolean;
    search?: string | number | boolean;
    status?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListProductsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/products`;
  const requestOptions = { ...options, skipAuth: true };
  return client.get<ListProductsResponse>(requestPath, { ...requestOptions, params });
}
